import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
} from "reactstrap";
import ApprentLogo from "../../../assets/images/ApprentAi-logo-Focused.png";

const SignInpage = () => {
  document.title = "Basic SignIn | Velzon - React Admin & Dashboard Template";
  return (
    <>
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="mt-4">
              <CardBody className="p-4">
                <div className="text-center mt-2">
                  <h5 className="text-primary">Welcome Back !</h5>
                  <div className="text-center  text-white-50">
                    <div>
                      <Link to="/" className="d-inline-block auth-logo">
                        <img src={ApprentLogo} alt="" height={100} />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="p-2 mt-4">
                  <form action="#">
                    <div className="mb-3">
                      <Label htmlFor="username" className="form-label">
                        Username
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="username"
                        placeholder="Enter username"
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <div className="float-end">
                        <Link
                          to="/auth-pass-reset-basic"
                          className="text-muted"
                        >
                          Forgot password?
                        </Link>
                      </div>
                      <Label className="form-label" htmlFor="password-input">
                        Password
                      </Label>
                      <div className="position-relative auth-pass-inputgroup mb-3">
                        <Input
                          type="password"
                          className="form-control pe-5 password-input"
                          placeholder="Enter password"
                          id="password-input"
                          required
                        />
                        <button
                          className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                          type="button"
                          id="password-addon"
                        >
                          <i className="ri-eye-fill align-middle"></i>
                        </button>
                      </div>
                    </div>

                    <Row>
                      <Col lg={6}>
                        <div className="mt-4">
                          <Button
                            color="success"
                            className="btn btn-success w-100"
                            type="submit"
                          >
                            Reset PassWord
                          </Button>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mt-4">
                          <Button
                            color="success"
                            className="btn btn-success w-100"
                            type="submit"
                          >
                            Login
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SignInpage;
